(function () {
    'use strict';

    angular.module("imApp").factory("p2DataTaskEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 11,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 12,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
